const json = {
    "basicInfo":{
        "name":"",
        "subtitle":"",
        "phone":"",
        "email":"",
        "location":""
    },

    "experiences": [{
            "name": "",
            "location": "",
            "startDate": "",
            "endDate": "",
            "description":"",
            "list": []
        }],

    "publications": [{
            "name": "",
            "description": "",
            "tasks":[],
            "languageUsed": [],
            "link": ""
        }],


    "education": [{
        "degree":"",
        "university":"",
        "startDate":"",
        "endDate":"",
        "description":""
    }],


    "strengths": [{
            "text": "",
            "icon": ""
        }],
    "skills": [],

    "certifications": [{
            "name": "",
            "from": ""
        }],

    "socialMedia": [{
            "name":"",
            "alt":"",
            "icon":"",
            "link": ""
        }],

    "projects": [
        {
            "name": "",
            "url": "",
            "description": "",
            "tools":[],
            "image":"",
            "imageAlt":""
        }
    ],
    "coverLetter": {
        "title":"",
        "to":"",
        "date":"",
        "paragraphs":[],
        "from":"",
        "work":"",
        "signature":true
    }
}

export default json